angular.module('elogbooksDirectives').directive('condition', ['apiClient', function (apiClient) {
    return {
        require: ['ngModel'],
        scope: {
            condition: '=ngModel',
            required: '=ngRequired',
            disabled: '=ngDisabled'
        },
        templateUrl: '/modules/directives/form-elements/condition/condition.html',
        link: function(scope){
            scope.options = [];
            apiClient.get('/conditiontypes?page=1&limit=999999').then(function(response) {
                scope.options = response.getData().conditiontypes;
            });
        }
    }
}]);
